
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2024-07-07-motion-canvas-1-intro",
      function () {
        return require("private-next-pages/blogs/2024-07-07-motion-canvas-1-intro/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2024-07-07-motion-canvas-1-intro"])
      });
    }
  